import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useState } from "react";
// import WalletToCore from "./WalletToCore";

function UnPostedTransactionData({ data }) {
  const [rows, setRows] = useState(20);
  const [first, setFirst] = useState(0);

  const handlePageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  if (!data) {
    return null;
  }

  const createdDateTemp = (date) => {
    const dateOnly = date?.createdate.toLocaleString().split("T");
    const timeOnly = dateOnly[1].split(".");

    return dateOnly[0] + " " + timeOnly[0];
  };

  return (
    <>
      <div>
        <div className="card">
          {/* <div className="p-d-flex p-jc-start">
                        <WalletToCore fileStausData={selectedFiles} />
                    </div> */}
          <DataTable
            header="Account Details"
            // selectionMode="multiple"
            // metaKeySelection={false}
            // selection={selectedFiles}
            // onSelectionChange={(e) => setSelectedFiles(e.value)}
            scrollable
            scrollHeight="400px"
            style={{ minWidth: "50rem" }}
            tableStyle={{ minWidth: "120rem" }}
            dataKey="fileDetailId"
            paginator
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={rows}
            first={first}
            rowsPerPageOptions={[10, 20, 50, 100, 200]}
            onPage={handlePageChange}
            value={data}
            emptyMessage="No data found."
          >
            {/* <Column selectionMode="multiple" headerStyle={{ width: "3rem" }}></Column> */}
            <Column filter field="amount" header="Amount" />
            <Column filter field="chequeNo" header="Cheque No" />
            <Column
              filter
              field="companyAccountNo"
              header="Company Account No"
            />
            <Column filter field="companyName" header="Company Name" />
            <Column
              filter
              field="createdate"
              body={createdDateTemp}
              header="Create Date"
            />
            <Column filter field="createuser" header="Create User" />
            <Column
              filter
              field="employeeAccountNo"
              header="Employee Account No"
            />
            <Column filter field="employeeCnic" header="Employee CNIC" />
            <Column filter field="employeeName" header="Employee Name" />
            <Column filter field="segment" header="Segment" />
            <Column filter field="statusCode" header="Status Code" />
          </DataTable>
        </div>
      </div>
    </>
  );
}

export default UnPostedTransactionData;
